var map = {
	"./en.json": [
		"102a",
		"lang-en-json"
	],
	"./id.json": [
		"2c62",
		"lang-id-json"
	],
	"./ko.json": [
		"8b3b",
		"lang-ko-json"
	],
	"./zh_TW.json": [
		"2ffa",
		"lang-zh_TW-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f676";
module.exports = webpackAsyncContext;